import { useEffect, useState } from "react";
import { useResourceUrl } from "@/features/resources/hooks/useResourceUrl";

export function AuthHeroPanel() {
  const [videoUrl, setVideoUrl] = useState<string | null>(null);
  const { getUrl } = useResourceUrl();

  useEffect(() => {
    let cancelled = false;

    void getUrl("hero-panel.mp4").then((url) => {
      if (!cancelled) setVideoUrl(url);
    });

    return () => {
      cancelled = true;
    };
  }, [getUrl]);

  return (
    <div className="w-[72%] h-[40rem] min-h-[40rem] rounded-sm overflow-hidden bg-[#dbe8f6] shadow-card max-[64rem]:h-[min(38rem,60vw)] max-[64rem]:min-h-[22rem] max-[48rem]:h-[18rem] max-[48rem]:min-h-[18rem]">
      {videoUrl ? (
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover"
          src={videoUrl}
        />
      ) : null}
    </div>
  );
}
